<template>
    <el-container class="index-con">
      <div class="index-header" style="border-bottom: solid 1px #e6e6e6;">
        <navcon></navcon>
      </div>
      <div class="index-page"></div>
      <div style="background-color: #f8f9fb;">
      <div class="main-con">
        <!-- 面包屑导航 -->
        <div class="breadcrumb">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/'}">海量数据</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/index/support?id=2'}">服务与支持</el-breadcrumb-item>
            <el-breadcrumb-item>{{ name }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="problem">
          <!-- <p class="name">{{name}}</p> -->
          <div class="authentication">
            <p class="title">{{params.name}}</p>
            <div class="value" v-html="params.value"></div>
          </div>
        </div>
      </div>
    </div>
      
  
      <el-footer class="index-footer" style="height: auto; background-color: #f0f4f7;border-top: solid 1px #e6e6e6">
        <footers></footers>
      </el-footer>
    </el-container>
  </template>
  <script>
  // 导入组件
  import navcon from '../../components/navcon.vue'
  import footers from '../../components/footers.vue'
//   import { bannerList } from '../../api/userMG'
  export default {
    name: 'support',
    data() {
      return {
        id:1,
        name:'常见问题',
        params:{},
      }
    },
    // 注册组件
    components: {
      navcon,
      footers
    },
    computed: {
      url() {
        return this.$store.getters.url;
      }
    },
    created() {
    //   this.getHome();
      this.params = this.$route.query.item;
      this.name = this.$route.query.name;
      console.log(this.params)
    },
   
    methods:{
        forward(id,name){
            console.log(id,name)
            this.id = id;
            this.name = name;
        },
        change(item){
          this.id = item.id;
          this.params = item;
          this.name = item.name
        }
     
    }
  }
  </script>
  
  <style scoped>
    
    @media (min-width: 1366px) {
    .main-con { 
        width: 1000px;
      }
    }
  @media (min-width: 1600px) {
    .main-con {
      width: 1300px;
    }
  }
  .aside-main{
    display: flex;
  }
  .index-main{
    padding: 10px 20px;
  }
  .main-con {
    margin: auto;
    padding-bottom: 40px;
  }
  .index-con {
    height: 100%;
    box-sizing: border-box;
    margin: auto;
  }
  .breadcrumb{
    padding: 30px 0;
  }
  /* .breadcrumb span{
    font-size: 12px;
  } */
  .title{
    font-family: SourceHanSansCN;
    font-weight: 600;
    font-size: 16px;
    color: #111;
    padding-bottom: 20px;
    text-align: center;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
  }
  .value{
    font-family: SourceHanSansCN;
    font-weight: 500;
    font-size: 13px;
    color: #333;
  }
   
  </style>
  


// WEBPACK FOOTER //
// src/views/index/supportDetail.vue